<template>
    <div class="page main-signin-wrapper">
        <div class="row signpages text-center">
            <div class="col-md-12">
                <Loading v-if="showLoading" />
                <div class="card">
                    <div class="row row-sm">
                        <div class="col-lg-6 col-xl-5 d-none d-lg-block text-center bg-primary details">
                            <div class="login-side-box">
                                <img src="/assets/img/user.svg" class="ht-100 mb-0" alt="user">
                            </div>
                        </div>
                        <div class="col-lg-6 col-xl-7 col-xs-12 col-sm-12 login_form ">
                            <div class="container-fluid">
                                <div class="row row-sm">
                                    <div class="card-body mt-2 mb-2">
                                        <img src="assets/img/brand/logo.png" class=" d-lg-none header-brand-img text-left float-left mb-4" alt="logo">
                                        <div class="clearfix"></div>
                                        <form v-on:submit.prevent="submit">
                                            <h5 class="text-right mb-2">فراموشی رمز عبور</h5>
                                            <div class="form-group text-right" v-if="!otpSent">
                                                <label>شماره همراه</label>
                                                <input class="form-control" dir="ltr" type="tel" maxlength="11" v-model="phone">
                                            </div>
                                            <div class="form-group text-right" v-if="otpSent && !session">
                                                <label>کد اعتبارسنجی</label>
                                                <input class="form-control" dir="ltr" type="tel" maxlength="5" v-model="otp">
                                            </div>
                                            <div class="form-group text-right" v-if="otpSent && session">
                                                <label>رمز عبور</label>
                                                <input class="form-control" dir="ltr" type="password" v-model="password">
                                            </div>
                                            <div class="form-group text-right" v-if="otpSent && session">
                                                <label>تکرار رمز عبور</label>
                                                <input class="form-control" dir="ltr" type="password" v-model="repeatPassword">
                                            </div>
                                            <div class="captcha-container mb-4">
                                                <img :src="captchaImage" class="captcha-image">
                                                <i class="si si-reload" data-toggle="tooltip" @click="createCaptcha" style="font-size: 30px;position: relative;top: 11px;margin-right: 10px;cursor: pointer" data-original-title="si-reload"></i>
                                            </div>
                                            <div class="form-group text-right">
                                                <label>کد امنیتی</label>
                                                <input type="text" class="form-control ltr-input" v-model="captcha" maxlength="6">
                                            </div>
                                            <button class="btn ripple btn-main-primary btn-block mb-3">فراموشی رمز عبور</button>
                                            <router-link class="btn btn-link mb-0" :to="{name: 'login'}">ورود به حساب کاربری</router-link>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data(){
        return {
            showLoading: false,
            phone: '',
            session: '',
            otpSent: false,
            otp: '',
            password: '',
            repeatPassword: '',
            captcha: '',
            captchaImage: ''
        }
    },
    methods: {
        submit(){
            this.showLoading = true;
            if(!this.otpSent){
                const postedData = {
                    phone: this.phone.replace('-','')
                };
                this.$api.post('user/RequestReset',postedData,{headers: {captcha: this.captcha}}).then(({data}) => {
                    if(data.status){
                        this.otpSent = true;
                        this.captcha = '';
                        this.createCaptcha();
                        this.$toast.success('کد اعتبارسنجی با موفقیت به شماره همراه شما ارسال شد');
                    }
                }).catch(({response}) => {
                    response.data.errors.map(err => this.$toast.error(err.message));
                }).finally(() => {
                    this.createCaptcha();
                    this.showLoading = false;
                });
            }else if(this.otpSent && !this.session){
                const postedData = {
                    phone: this.phone.replace('-',''),
                    verificationCode: this.otp
                };
                this.$api.post('user/ObtainSession',postedData,{headers: {captcha: this.captcha}}).then(({data}) => {
                    if(data.status){
                        this.session = data.result.sessionId;
                        this.captcha = '';
                        this.createCaptcha();
                        this.$toast.success('رمز عبور جدید خود را وارد کنید');
                    }
                    else{
                        this.createCaptcha();
                        this.$toast.error('کد وارد شده معتبر نمی‌باشد');
                    }
                }).catch(({response}) => {
                    response.data.errors.map(err => this.$toast.error(err.message));
                }).finally(() => {
                    this.showLoading = false;
                });
            }else if(this.otpSent && this.session){
                const postedData = {
                    password: this.password,
                    passwordConfirm: this.repeatPassword,
                    sessionId: this.session
                };
                this.$api.post('user/ChangePassword',postedData).then(({data}) => {
                    if(data.status){
                        this.$toast.success('رمز عبور شما با موفقیت تغییر کرد');
                        this.$router.push({name: 'login'});
                    }
                }).catch(({response}) => {
                    response.data.errors.map(err => this.$toast.error(err.message));
                }).finally(() => {
                    this.showLoading = false;
                });
            }
        },
        async createCaptcha(){
            let imgSrc = await this.generateCaptcha();
            this.captchaImage = imgSrc || this.captchaImage;
        }
    },
    created(){
        this.createCaptcha();
    }
}
</script>